import { AscendLogo } from './AscendLogo';

interface AscendHorizonLogoProps {
  className?: string;
  /** Symbol height in px. Wordmark scales proportionally. Default 24. */
  size?: number;
}

/**
 * Ratio between wordmark font-size and symbol height. Figtree's cap-height is
 * ~70% of em while the AscendLogo SVG fills its full bounding box, so making
 * the wordmark slightly smaller visually balances cap-height with the symbol.
 */
const WORDMARK_TO_SYMBOL_RATIO = 0.95;

/**
 * Official Ascend "Horizon" logo: symbol + Ascend wordmark side by side.
 * Wordmark is rendered as text in Figtree (loaded globally via Google Fonts).
 *
 * Colour: both the symbol and the wordmark inherit currentColor, so callers
 * control colour via Tailwind text classes (e.g. `text-primary`).
 */
export function AscendHorizonLogo({ className, size = 24 }: AscendHorizonLogoProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ''}`}>
      <AscendLogo size={size} />
      <span
        className="font-semibold leading-none tracking-tight"
        style={{
          fontSize: `${size * WORDMARK_TO_SYMBOL_RATIO}px`,
          fontFamily: 'var(--font-figtree)',
        }}
      >
        Ascend
      </span>
    </span>
  );
}
